import { z } from 'zod'
import { getDuplicatesRefinement } from 'src/util/src/zod'
import { InvestorTypeSchema } from './InvestorType'
import { NameSchema } from '../../Generic/models/Name'
import { UrlSchema } from '../../Generic/models/Url'

export const InvestorSchema = z.object({
  type: InvestorTypeSchema,
  name: NameSchema,
  url: UrlSchema,
})

export const InvestorsSchema = z.array(InvestorSchema)
  .superRefine(getDuplicatesRefinement('Investor', parseInvestorUid))

export const InvestorUidSchema = InvestorSchema.pick({
  url: true,
})

export type Investor = z.infer<typeof InvestorSchema>

export type InvestorUid = z.infer<typeof InvestorUidSchema>

export function parseInvestor(investor: Investor): Investor {
  return InvestorSchema.parse(investor)
}

export function parseInvestors(investors: Investor[]): Investor[] {
  return InvestorsSchema.parse(investors)
}

export function parseInvestorUid(investorUid: InvestorUid): InvestorUid {
  return InvestorUidSchema.parse(investorUid)
}
